import { useCallback, useEffect, useState } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { ngContext } from '../../../../core/services/ng.delegate';
import { splitOrderInvoicesPageStateAtom } from '../split_order_invoices_list_atoms';
import { useSplitOrderInvoicesListDestroy } from '../table/useSplitOrderInvoicesListDestroy';
import { PreloadState } from '../../../../core/page/page.types';

export const useSplitOrderInvoicesInit = (): boolean => {
    const [preloadState, setPreloadState] = useState<PreloadState>('init');
    const setPageState = useSetImmerAtom(splitOrderInvoicesPageStateAtom);
    useSplitOrderInvoicesListDestroy();

    const preloadPage = useCallback(async () => {
        const ctx = ngContext();
        setPageState(draft => {
            draft.canEdit = !!ctx && !!ctx.User;
            draft.init = false;
            draft.loading = false;
            draft.action = 'QUERY';
            return draft;
        });
        setPreloadState('done');
    }, [setPageState]);

    useEffect(() => {
        if (preloadState === 'init') {
            setPreloadState('loading');
            preloadPage();
        }
    }, [preloadState, setPreloadState, preloadPage]);

    return preloadState === 'done';
};
